import { useEffect, useState } from "react";
import { useError } from "../context/ErrorContext";
import '../styles/components/ChangeDifficultyBonusForm.css';
import useApi from "../hooks/useApi";

const ChangeDifficultyBonusForm = ({ mapKey, user, onDifficultyChanged, map }) => {
    const api = useApi();
    const { showError } = useError();
    const [difficultyBonus, setDifficultyBonus] = useState(map?.difficultyBonus ?? 0);

    useEffect(() => {
        setDifficultyBonus(map?.difficultyBonus ?? 0);
    }, [map]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (difficultyBonus === '') {
            showError('Difficulty bonus must be a number.');
            return;
        }

        const parsedDifficultyBonus = Number(difficultyBonus);
        if (!Number.isFinite(parsedDifficultyBonus)) {
            showError('Difficulty bonus must be a number.');
            return;
        }

        try {
            await api.leaderboards.updateDifficultyBonus(
                mapKey,
                parsedDifficultyBonus,
                user?.token
            );
            onDifficultyChanged?.();
        } catch (err) {
            // Errors are already shown by the API layer.
        }
    };

    return (
        <form className="change-difficulty-bonus-form" onSubmit={handleSubmit}>
            <h3>Change Difficulty Bonus</h3>
            <label htmlFor="difficulty-bonus-input">Difficulty Bonus:</label>
            <div className="input-cnt">
                <input
                    id="difficulty-bonus-input"
                    type="number"
                    onChange={(e) => setDifficultyBonus(e.target.value)}
                    value={difficultyBonus}
                />
                <button className="btn btn-primary btn-small">Save</button>
            </div>
        </form>
    );
};

export default ChangeDifficultyBonusForm;
